import clsx from 'clsx';
import { section_links } from 'root/data/section_links';
import LinkIcon from 'components/LinkIcon/LinkIcon';
import Text from 'ui/Text/Text';
import './Hero.scss';
import './HeroAnim.scss';
import { useContext } from 'react'
import { ControllerContext } from 'components/Controller/Controller';
import { screens } from '../constants'

const Hero: React.FC = () => {
  const { dispatchActive } = useContext(ControllerContext)
  return (
    <div className="hero -appearing section" id="hero">
      <div className="container hero__container">
        <h1 className="hero__title hero__title_up">
          <span>Uniting</span>
        </h1>
        <div className="hero__content">
          {Object.entries(section_links).map(([title, _]) => (
            <button
              key={title}
              className={clsx(
                'hero__link',
                `hero__link_${title.toLowerCase()}`
              )}
            >
              <LinkIcon className="hero__link-icon">
                <img src={_[0]} alt="icon" />
              </LinkIcon>
              <span className='hero__link-name'>
                Galaxy "<span>{_[1]}</span>"
              </span>
            </button>
          ))}
          <button onClick={() => dispatchActive(screens.SITEMAP)} className="hero__start">
            <span>Start</span>
            <img src={require('images/sphere-journey.png')} alt="journey" />
            <span>Journey</span>
          </button>
        </div>
        <h2 className="hero__title hero__title_down">
          for <span>Blockchain</span>
        </h2>
        <Text className="hero__text">
          BitBloom organizes information and provides tools to enable seamless
          coordination across the DAO ecosystem
        </Text>
      </div>
    </div>
  );
};

export default Hero;
